import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery } from '@tanstack/react-query';

interface Props {
  orderId: string;
}

export const getTransactionQueryKey = ({ orderId }: { orderId: string }) => [
  'order.transactions',
  orderId,
];

export const useGetOrderTransactions = ({ orderId }: Props) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: getTransactionQueryKey({ orderId }),
    queryFn: () => OrdersClient.getOrderTransactions(orderId),
  });
  const noTransactionFound = !isLoading && data && data.length === 0;

  return {
    refetchTransactions: refetch,
    transactions: data ?? [],
    noTransactionFound,
    isLoadingTransactions: isLoading,
  };
};
